import { createUseStyles } from 'react-jss'

const useDropdownStyles = createUseStyles({
  disabled: {
    opacity: 0.4,
    pointerEvents: 'none'
  }
})

export { useDropdownStyles }
